import { register } from '../../../JavaScript/Utils'

const BackToTop = el => {
  const activationOffset = 500

  el.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }))

  window.addEventListener('scroll', () => { el.classList.toggle('is--active', window.pageYOffset > activationOffset) })
}

register('BackToTop', BackToTop)
